import { useQuery } from "react-query"
import * as api from '../api'
import { Params } from "../commonTypes"

export const useIntentQuery = (params: Params.Intent) => {
    return useQuery(['intent', params], () => api.intent(params))
}